var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputWrapper } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useState } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/mode-handlebars';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-tomorrow';
import styles from './inputTemplate.module.scss';
const defaultEditorMode = 'handlebars';
const defaultEditorOptions = {
    tabSize: 2,
    minLines: 10,
    maxLines: 10,
    fontSize: 14,
    enableBasicAutocompletion: true,
    enableLiveAutocompletion: true,
    showPrintMargin: false,
    showGutter: true,
    readOnly: false,
};
/**
 * A component that wraps the AceEditor furthermore with input wrapper from
 * habla which adds all validation and input states automatically.
 */
export const InputTemplate = (_a) => {
    var { height, readOnly, disabled, active, defaultHidden, previewContent, previewButton, editorClassName, editorOptions, fieldTemplateId, status, prefix, suffix, icon, placeholder, mode = defaultEditorMode } = _a, editorProps = __rest(_a, ["height", "readOnly", "disabled", "active", "defaultHidden", "previewContent", "previewButton", "editorClassName", "editorOptions", "fieldTemplateId", "status", "prefix", "suffix", "icon", "placeholder", "mode"]);
    editorOptions = Object.assign(Object.assign(Object.assign({}, defaultEditorOptions), editorOptions), ((disabled || readOnly) && { readOnly: true }));
    const [showTemplateContent, setShowTemplateContent] = useState(defaultHidden ? false : true);
    return (_jsxs(InputWrapper, Object.assign({ className: classnames(styles.inputWrapper, {
            [styles.inputWrapperWithPreview]: !!previewContent,
        }), status: status, active: active, prefix: prefix, suffix: suffix, icon: icon }, { children: [previewButton && (_jsx("div", Object.assign({ role: "button", className: styles.previewButton }, { children: previewButton }))), previewContent ||
                (showTemplateContent ? (_jsx(AceEditor, { theme: "tomorrow", width: "100%", height: height, name: fieldTemplateId, mode: mode, scrollMargin: [5, 5], setOptions: Object.assign(Object.assign(Object.assign({}, editorOptions), (disabled && {
                        highlightGutterLine: false,
                        highlightActiveLine: false,
                    })), { 
                        // fix to prevent "Could not load worker" error when changing `mode`
                        useWorker: false }), className: classnames(styles.editor, editorClassName, {
                        [styles.editorDisabled]: disabled,
                        [styles.editorGreyedOut]: readOnly,
                    }), placeholder: placeholder, value: editorProps.value, onChange: editorProps.onChange, onFocus: editorProps === null || editorProps === void 0 ? void 0 : editorProps.onFocus })) : (_jsxs("div", Object.assign({ className: styles.templateCondition }, { children: ["If you want to customize this template click", ' ', _jsx("a", Object.assign({ href: "#", onClick: (event) => {
                                event.preventDefault();
                                setShowTemplateContent(!showTemplateContent);
                            } }, { children: "here" }))] }))))] })));
};
